export const noticeExtractorKeys = {
  all: [{ module: 'noticeExtractor' }] as const,
  workflowStatuses: () => [{ ...noticeExtractorKeys.all[0], scope: 'workflowStatus' }] as const,
  workflowStatus: (workflowId: string) => [{ ...noticeExtractorKeys.workflowStatuses()[0], workflowId }] as const,
};
